import axiosInstance from '../api';

export interface CounterDecisionStat {
  label: string;
  value: string;
}

export interface CounterDecisionPath {
  key: 'accept' | 'counter' | 'walkAway';
  title: string;
  subtitle: string;
  recommended: boolean;
  cta: string;
  stats: CounterDecisionStat[];
}

export interface SuggestedCounterTerms {
  price: number;
  closingDate: string | null;
  earnestMoney: number;
  concessions: number;
  inspectionPeriod: number | null;
  contingent: boolean;
  appliances: boolean;
  additionalTerms: string | null;
  loan: number;
  paymentMethod: string;
  homeWarrantyType: 'NONE' | 'SELLER' | 'BUYER';
  termiteInspection: boolean;
  termiteBond: boolean;
  sewerInspection: boolean;
  newSurvey: boolean;
  bagentComm: number;
}

export interface CounterDecisionPayment {
  atCounter: number;
  atYourOffer: number;
  delta: number;
  summary: string;
}

export interface CounterDecision {
  offerId: string;
  listingId: string;
  currentRoundId: string;
  status: 'ready' | 'expired';
  address: string;
  city: string;
  counterPrice: number;
  yourPrice: number;
  listPrice: number | null;
  expiresAt: string;
  hoursLeft: number;
  expiryLabel: string;
  subhead: string;
  read: string;
  paths: CounterDecisionPath[];
  suggestedCounter: SuggestedCounterTerms | null;
  payment: CounterDecisionPayment | null;
  alternatives: number;
}

const counterAnalysisService = {
  get: async (offerId: string): Promise<CounterDecision> => {
    const res = await axiosInstance.get(`/counter-analysis/${offerId}`);
    return res.data;
  },
};

export default counterAnalysisService;
